import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './basepriceUsers.component.html',
        providers: [ SharedService,PopupSegmentComponent]
    // styleUrls: ['./dashboard.component.scss']

})
export class BasePriceUsersComponent implements OnInit {

itemsTotalAdv : number =0;
country = '';
countryCode : number =0;
 objLoaderStatus: boolean = false;
 id : number;
 data : any =[];
 editFlag = [];
 page : number =1;
  message ="";
   errormessage = "";
 errorUpdate =[];
 errormessageDisc = "";
 searchmessage = "";
 errorUpdatedisc = [];
 searchText = "";
  charFlag :boolean = false;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
     private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {
    

    
    }

    ngOnInit() {
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

    var token = this.localstorage.getStorage("token");
                  this.loaderService.displayLoader(true);

 this.shareService.CallDatawithToken("admin/getAllPrivilegedUserPrice?currentSize=25", null, token).subscribe((result) => {
        if(result.data){
        this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
                      this.loaderService.displayLoader(false);

        }
      });


    }



   changeFlag(id){
  this.id = id;
  console.log(this.data);
  var i=0;
  for(i=0;i<this.data.length;i++){
    this.editFlag[this.data[i].id] = false;
    console.log(this.data[i].id == id);
if(this.data[i].id == id){
this.editFlag[id] = true;
}
}
}

editPrice(id,price,discount){
  this.errormessage = "";
  this.errormessageDisc = "";
        var token = this.localstorage.getStorage("token");
        var data : any = {};
        data.usedId = id;
        data.price = parseInt(price);
        data.percentDiscount = parseInt(discount);
        console.log("price"+price);
        if(price.toString().trim() !== '' && 
        discount.toString().trim() !== '' && discount <=100){
    this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/updatePrivilegedUser",data,token).subscribe((result) => {
    console.log(result.data);
    if(result.data && result.data.status == true){
         this.message = "Price updated successfully";
         this.showUpdate();
       this.editFlag[id] = false;
    this.loaderService.displayLoader(false);
    }
    else{
          this.loaderService.displayLoader(false);

       this.message =result.meta.message;
    }
    this.loaderService.displayLoader(false);
});
 }
        else{
          if(price.toString().trim() == ''){
          this.errormessage = "Price can not be empty";
                    this.errorUpdate[id] = true;
        }
        if(discount.toString().trim() == ''){
          this.errormessageDisc = "Discount can not be empty";
 this.errorUpdatedisc[id] = true;

        }
          if(discount >100){
          this.errormessageDisc = "Discount can not be greater than 100";
 this.errorUpdatedisc[id] = true;


        }
            
        }
}

resetPrice(id){
  var i=0
        var token = this.localstorage.getStorage("token");
           this.loaderService.displayLoader(true);
this.shareService.callApiWithTokenDelete("admin/deletePrivilegedUser?id="+id,{},token).subscribe((result) => {
    console.log(result.data);
    if(result.data && result.data.status == true){
       this.message = "Price has been reset successfully";
         this.showDelete(id);
       this.editFlag[id] = false;
    
//window.location.reload();    
    }
    else{
          this.loaderService.displayLoader(false);

    this.message =result.meta.message;
    }
    this.loaderService.displayLoader(false);
});
}

searchUserPrice(searchtext){
 // this.searchText = searchtext;
this.itemsTotalAdv =0;
      var token = this.localstorage.getStorage("token");
        this.errormessage ="";
          this.searchmessage = "";
              this.searchText = this.searchText.trim();
  this.page = 1;
if(this.searchText.length == 0){
this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllPrivilegedUserPrice?currentPage=1&currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);

    }
         });
}
       else  if(searchtext.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
    this.loaderService.displayLoader(true);
 this.shareService.CallDatawithToken("admin/searchPrivilegedUser?currentPage=1&currentSize=25&q="+searchtext, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }else{
        this.searchmessage = "No records found";
      }
      this.loaderService.displayLoader(false);
 
   }
         });
       }
}


nextPrice(event){
this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
           this.errormessage ="";
             this.searchmessage = "";
     var token = this.localstorage.getStorage("token");
    this.searchText = this.searchText.trim();

    if(this.searchText =='' || this.searchText == undefined){
               this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllPrivilegedUserPrice?currentSize=25&currentPage="+event, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
         if(this.searchText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                  this.loaderService.displayLoader(true);

      this.shareService.CallDatawithToken("admin/searchPrivilegedUser?currentPage="+event+"&q="+this.searchText+"&currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }else{
        this.searchmessage = "No records found";
      }
        this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
        
}

 allUsers(){
        this.page = 1;
   this.errormessage ="";
          this.searchmessage = "";
      this.searchText = '';
      this.itemsTotalAdv = 0;
       var token = this.localstorage.getStorage("token");
        this.loaderService.displayLoader(true);
 
  this.shareService.CallDatawithToken("admin/getAllPrivilegedUserPrice?currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
            this.loaderService.displayLoader(false);

    }
         });
    }

    downloadUsers(){
        var token = this.localstorage.getStorage("token");

window.location.href = this.shareService.apiUrl+"master/getCsvPrivilegedUser?token="+token;

    }

 showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Base Price Users Information', 
                message:this.message,
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 
                });
        }

         showDelete(id) {
           var i=0;
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Base Price Users Information', 
                message:this.message,
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
   for(i=0;i<this.data.length;i++){
         if(this.data[i].id == id){
       this.data[i].price = 0;

         }
       }                });
        }
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/pricingdetails/basepriceUsers.component.ts